import { DirectionProvider, Drawer } from '@mantine/core';
import cs from 'classnames';
import { useRouter } from 'next/router';
import React, { type FC } from 'react';
import { usePrepareBurgerMenuData } from '@/Module/DefaultLayout/Hook';
import { HamburgerItems, HamburgerMenuCategory } from '@/Module/DefaultLayout/Model';
import { IconCloseDrawer } from '@/Module/Icon';
import { useAppSelector } from '@/Module/Store/Hook';
import styles from './BurgerMenu.module.scss';
interface IProps {
  close: () => void;
  opened: boolean;
}
const BurgerMenuMobile: FC<IProps> = ({
  opened,
  close
}) => {
  const menuData = usePrepareBurgerMenuData();
  const router = useRouter();
  const unRead = useAppSelector(state => state.notification.totalUnreadMenu);
  return <DirectionProvider initialDirection="rtl" data-sentry-element="DirectionProvider" data-sentry-component="BurgerMenuMobile" data-sentry-source-file="BurgerMenuMobile.tsx">
      <Drawer opened={opened} onClose={close} size="62%" position="right" closeButtonProps={{
      radius: 'xl',
      icon: <IconCloseDrawer />
    }} overlayProps={{
      blur: 5
    }} title="سامانه آموزش مجازی آی‌نو" className="" classNames={{
      header: styles.header,
      title: styles.title,
      content: 'overflow-hidden max-h-[100vh] overflow-y-scroll ',
      body: 'flex flex-col '
      // close: 'focus:none'
    }} data-sentry-element="Drawer" data-sentry-source-file="BurgerMenuMobile.tsx">
        {menuData.map(menuGroup => <div key={menuGroup.categoryId} className={cs(`${menuGroup.categoryId === HamburgerMenuCategory.EXIT && 'grow flex flex-col justify-end mb-6'}`)}>
            <p key={menuGroup.categoryId} className="mb-3 text-right text-xs text-blackThree">
              {menuGroup.categoryName}
            </p>
            {menuGroup.children.map(item => <div key={`${menuGroup.categoryId} - ${item.itemId}`} className="relative">
                <button type="button" key={item.itemId} onClick={() => {
            router.push(item.link).then(() => close());
          }} className={cs('flex items-center justify-start gap-2 text-xs font-medium not-italic leading-[normal]', `${item.itemId === HamburgerItems.EXIT ? 'text-redTwo' : 'text-blackFive'}`)}>
                  {item.icon}
                  {item.itemName}
                </button>
                {item.itemId === HamburgerItems.NOTIFICATION && unRead > 0 && <div className="absolute left-4 top-0 flex h-[20px] w-[20px] items-center justify-center rounded-full bg-redTwo pt-1 text-[12px] text-white sm:left-0">
                    {unRead}
                  </div>}
                {item.itemId !== HamburgerItems.EXIT && <div className="my-4 h-[1px] min-w-full bg-grayOne" />}
              </div>)}
          </div>)}
      </Drawer>
    </DirectionProvider>;
};
export default React.memo(BurgerMenuMobile);